/* eslint-disable no-console */

import { getCompaniesMentors } from '../api/v1/companiesMentors';
import {
  FETCH_MENTORS_PROGRESS,
  INC_COUNTER,
  FETCH_COMPANY_MENTORS
} from '../constants/actionTypes';

export const fetchAllCompaniesMentorsProgress = () => ({
  type: FETCH_MENTORS_PROGRESS
});

export const incrementCounter = () => ({
  type: INC_COUNTER
});

export const fetchCompaniesMentors = () => (dispatch, start) => {
  start(FETCH_COMPANY_MENTORS);
  return getCompaniesMentors().then(response => {
    return { value: response.data };
  });
};



// WEBPACK FOOTER //
// ./src/actions/companiesMentors.js